import React from "react";
import styled from "@emotion/styled";

const RewardHistory = ({ date, reward }) => {
  function formatCustomDate(oldDate) {
    const date = new Date(oldDate);
    const options = { day: "numeric", month: "short", year: "numeric" };
    const formattedDate = date.toLocaleDateString("en-GB", options);

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "pm" : "am";

    hours = hours % 12 || 12;

    return `${formattedDate} - ${hours}:${minutes}${ampm}`;
  }


  

  return (
    <HistoryContainer>
      <LogoContainer>
        <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.67969 6.32812C3.71875 6.92969 5.25 7.3125 7 7.3125C8.75 7.3125 10.2539 6.92969 11.293 6.32812C12.3594 5.72656 12.6875 5.09766 12.6875 4.6875C12.6875 4.30469 12.3594 3.67578 11.293 3.04688C10.2539 2.47266 8.75 2.0625 7 2.0625C5.25 2.0625 3.71875 2.47266 2.67969 3.04688C1.61328 3.67578 1.3125 4.30469 1.3125 4.6875C1.3125 5.09766 1.61328 5.72656 2.67969 6.32812ZM7 0.75C10.8555 0.75 14 2.52734 14 4.6875V7.75C14 9.69141 10.8555 11.25 7 11.25C3.11719 11.25 0 9.69141 0 7.75V4.6875C0 2.52734 3.11719 0.75 7 0.75ZM5.90625 8.59766V9.91016C6.23438 9.9375 6.61719 9.9375 7 9.9375C7.35547 9.9375 7.73828 9.9375 8.09375 9.91016V8.59766C7.73828 8.625 7.35547 8.625 7 8.625C6.61719 8.625 6.26172 8.625 5.90625 8.59766ZM5.03125 8.48828C4.40234 8.37891 3.80078 8.24219 3.28125 8.05078V9.33594C3.77344 9.52734 4.375 9.69141 5.03125 9.80078V8.48828ZM1.3125 6.98438V7.75C1.3125 7.94141 1.47656 8.43359 2.40625 8.95312V7.66797C1.99609 7.47656 1.61328 7.25781 1.3125 6.98438ZM8.96875 9.80078C9.59766 9.69141 10.1992 9.52734 10.7188 9.33594V8.02344C10.1719 8.21484 9.57031 8.37891 8.96875 8.48828V9.80078ZM11.5938 8.95312V8.92578C12.4961 8.43359 12.6875 7.94141 12.6875 7.75V6.98438C12.3594 7.23047 12.0039 7.47656 11.5938 7.66797V8.95312ZM7 4.03125C5.87891 4.03125 4.92188 4.19531 4.23828 4.38672C3.91016 4.49609 3.69141 4.60547 3.58203 4.6875C3.69141 4.79688 3.91016 4.90625 4.23828 5.01562C4.92188 5.20703 5.87891 5.34375 7 5.34375C8.09375 5.34375 9.05078 5.20703 9.73438 5.01562C10.0625 4.90625 10.2812 4.79688 10.418 4.6875C10.2812 4.60547 10.0625 4.49609 9.73438 4.38672C9.05078 4.19531 8.09375 4.03125 7 4.03125ZM11.8125 4.6875C11.8125 5.17969 11.4844 5.53516 11.2109 5.72656C10.9102 5.94531 10.5273 6.10938 10.1172 6.24609C9.29688 6.51953 8.17578 6.65625 7 6.65625C5.79688 6.65625 4.67578 6.51953 3.85547 6.24609C3.44531 6.13672 3.0625 5.94531 2.76172 5.72656C2.48828 5.53516 2.1875 5.17969 2.1875 4.6875C2.1875 4.22266 2.48828 3.86719 2.76172 3.67578C3.0625 3.45703 3.44531 3.26562 3.85547 3.15625C4.67578 2.88281 5.79688 2.71875 7 2.71875C8.17578 2.71875 9.29688 2.88281 10.1172 3.15625C10.5273 3.26562 10.9102 3.45703 11.2109 3.67578C11.4844 3.86719 11.8125 4.22266 11.8125 4.6875Z" fill="#5954DE"/>
        </svg>
      </LogoContainer>
      <TextContainer>
        <DateText>{formatCustomDate(date)}</DateText>
        <ExtraContainer>
        <VendorText style={{ color: "rgba(100, 116, 139, 1)" }}>
            Amount
        </VendorText>
        <AmountText>£{reward.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</AmountText>
        </ExtraContainer>
      </TextContainer>
    </HistoryContainer>
  );
};

const HistoryContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 8px;
  gap: 8px;
  width: 100%;
`;

const LogoContainer = styled.div`
  width: 42px;
  height: 36px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background-color: rgba(89, 84, 222, 0.1);
`;

const TextContainer = styled.div`
  gap: 4px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const DateText = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 14px;
`;

const VendorText = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
`;

const AmountText = styled.span`
  color: rgba(118, 192, 101, 1);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  line-height: 160%;
`;

const ExtraContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export default RewardHistory;
